import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const mapStateToProps = (state) => ({ ...state });

class NightsInputValue extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getNightsText = () => {
    const { nightsFrom, nightsTo } = this.props;

    if (nightsFrom === nightsTo) {
      return nightsFrom;
    }

    return `${nightsFrom} - ${nightsTo}`;
  };

  render() {
    return <div>{this.getNightsText()}</div>;
  }
}

NightsInputValue.propTypes = {
  nightsFrom: PropTypes.number.isRequired,
  nightsTo: PropTypes.number.isRequired,
};

export default connect(mapStateToProps, null)(NightsInputValue);
